import { RootState } from '../store/create-store';
import { FaqsState } from 'store/faqs/types';

export const getFaqsState = (state: RootState): FaqsState => state.faqs;
